import { render, staticRenderFns } from "./taBtnBack.vue?vue&type=template&id=5eefb614&scoped=true&"
import script from "./taBtnBack.vue?vue&type=script&lang=js&"
export * from "./taBtnBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eefb614",
  null
  
)

export default component.exports